import type { Achievement } from "../achievement.types";

export const aHundredLessonsAchievement: Achievement = {
  id: "aHundredLessons",
  name: "A Hundred Lessons",
  description: "Ariadne has learned from a hundred of your games.",
  icon: "book-open-variant",
  // Rule unchanged from v1's Schooled (spec 2026-10-20 §3.2).
  check: (gameReport) => (gameReport?.ariadne?.games ?? 0) >= 100,
};
